<template>

    <uw-page class="pm-schedule-page" title="">

        <template slot="search">

            <div class="pm-schedule-header">

                <div class="pm-schedule-title-bar">

                    <i class="el-icon-date pm-schedule-title-icon"></i>

                    <span class="pm-schedule-title-text">日历看板</span>

                </div>

                <div class="pm-schedule-filter-bar">

                    <el-form inline label-width="58px" class="pm-schedule-filter-form">

                        <el-form-item label="指定人员">

                            <users-select v-model="post.search.users_id" multiple />

                        </el-form-item>

                        <el-form-item label="指定日期">

                            <el-date-picker

                                v-model="targetDate"

                                type="date"

                                value-format="yyyy-MM-dd"

                                placeholder="请选择日期"

                                clearable />

                        </el-form-item>

                        <el-form-item class="pm-schedule-filter-actions">

                            <el-button type="primary" @click="handleSearch">查询</el-button>

                            <el-button @click="handleReset">重置</el-button>

                        </el-form-item>

                    </el-form>

                </div>

                <div class="pm-schedule-toolbar">

                    <div class="pm-schedule-toolbar-left">

                        <el-button-group class="pm-schedule-nav-group">

                            <el-button size="mini" icon="el-icon-arrow-left" @click="shiftRange(-1)">上一周</el-button>

                            <el-button size="mini"  @click="goThisWeek" style="margin: 0 16px;">本周</el-button>

                            <el-button size="mini" @click="shiftRange(1)">

                                下一周<i class="el-icon-arrow-right el-icon--right"></i>

                            </el-button>

                        </el-button-group>

                        <span v-if="rangeLabel" class="pm-schedule-range">{{ rangeLabel }}</span>

                    </div>

                    <div class="pm-schedule-toolbar-center">

                        <el-radio-group v-model="viewMode" size="mini" class="pm-schedule-view-group" @change="handleViewModeChange">

                            <el-radio-button label="week">单周</el-radio-button>

                            <el-radio-button label="biweek">双周</el-radio-button>

                        </el-radio-group>

                        <div class="pm-schedule-switches">

                            <div class="pm-schedule-switch-item">

                                <span class="pm-schedule-switch-label">仅显示空闲</span>

                                <el-switch v-model="post.search.only_available" @change="search()" />

                            </div>

                            <div class="pm-schedule-switch-item">

                                <span class="pm-schedule-switch-label">含周末</span>

                                <el-switch v-model="post.search.include_weekend" @change="search()" />

                            </div>

                        </div>

                    </div>

                    <div class="pm-schedule-toolbar-right">

                        <span class="pm-schedule-legend">

                            <span class="pm-schedule-legend-item"><i class="icon planned el-icon-date"></i>计划</span>

                            <span class="pm-schedule-legend-item"><i class="icon in-progress el-icon-video-play"></i>进行中</span>

                            <span class="pm-schedule-legend-item"><i class="icon complete el-icon-check"></i>完成</span>

                            <span class="pm-schedule-legend-item"><i class="icon abnormal el-icon-warning"></i>异常</span>

                            <span class="pm-schedule-legend-item"><i class="icon continuing"></i>持续中</span>

                            <span class="pm-schedule-legend-item"><i class="icon leave el-icon-coffee-cup"></i>请假</span>

                        </span>

                    </div>

                </div>

            </div>

        </template>



        <div class="pm-schedule-table">

            <vxe-table

                ref="xTable"

                height="100%"

                :data="table"

                :loading="loading"

                :stripe="false"

                :row-config="{ keyField: 'id', isHover: true, height: 40 }"

                :tree-config="{ transform: true, rowField: 'id', parentField: 'parent_id', expandAll: true, reserve: true }"

                :cell-style="tableCellStyle"

                :header-cell-style="tableHeaderCellStyle">

                <vxe-column min-width="200" field="name" title="成员" fixed="left" tree-node>

                    <template #default="{ row }">

                        <template v-if="row.row_type === 'organize'">

                            <span class="pm-schedule-organize-name">{{ row.name }}</span>

                        </template>

                        <template v-else>

                            <div class="pm-schedule-user-cell">

                                <el-avatar :size="26" :src="row.avatar">{{ row.name?.[0] }}</el-avatar>

                                <el-link
                                    type="primary"
                                    :underline="false"
                                    :title="row.name"
                                    @click="$refs.employeeDrawer.Open(row.id)">{{ row.name }}</el-link>

                            </div>

                        </template>

                    </template>

                </vxe-column>

                <vxe-column

                    v-for="date in dates"

                    :key="date"

                    :field="date"

                    min-width="88"

                    align="center">

                    <template #header>

                        <div class="pm-schedule-date-head" :class="{ 'is-today': date === today, 'is-target': date === targetDate && date !== today }">

                            <div>{{ formatDate(date, 'MM/dd') }}</div>

                            <div class="weekday">{{ weekdayLabel(date) }}</div>

                        </div>

                    </template>

                    <template #default="{ row }">

                        <div

                            v-if="row.row_type === 'user'"

                            class="pm-schedule-cell"

                            :class="cellClass(row.days?.[date])"

                            @click="openCell(row, date)">

                            <span class="pm-schedule-cell-inner" :title="cellText(row.days?.[date])">

                                <i v-if="cellIcon(row.days?.[date])" :class="cellIcon(row.days?.[date])"></i>

                                <span class="pm-schedule-cell-text">{{ cellText(row.days?.[date]) }}</span>

                            </span>

                        </div>

                    </template>

                </vxe-column>

            </vxe-table>

        </div>



        <pm-schedule-cell-drawer ref="cellDrawer" @onChange="handleCellDrawerChange" />

        <hrm-employee-drawer ref="employeeDrawer" />

    </uw-page>

</template>

<script>

export default {

    data () {

        return {

            loading: false,

            table: [],

            dates: [],

            dateRange: [],

            today: '',

            viewMode: 'week',

            rangeAnchor: null,

            targetDate: '',

            post: {

                search: {

                    users_id: [],

                    date_range: [],

                    only_available: false,

                    include_weekend: false,

                },

            },

        }

    },

    computed: {

        rangeLabel () {

            if (!this.dateRange.length) {

                return ''

            }

            const [start, end] = this.dateRange

            return `${start} ~ ${end}（第${this.weekNumber(start)}周）`

        },

    },

    mounted () {

        this.resetRange()

    },

    methods: {

        handleViewModeChange () {

            this.resetRange()

        },

        goThisWeek () {

            this.resetRange()

        },

        resetRange (reload = true) {

            this.rangeAnchor = this.getMonday(new Date())

            this.applyRange(reload)

        },

        shiftRange (step) {

            const days = this.viewMode === 'week' ? 7 : 14

            const anchor = new Date(this.rangeAnchor)

            anchor.setDate(anchor.getDate() + (step * days))

            this.rangeAnchor = this.formatDate(anchor, 'yyyy-MM-dd')

            this.applyRange()

        },

        applyRange (reload = true) {

            const start = this.rangeAnchor

            const endDate = new Date(start)

            endDate.setDate(endDate.getDate() + (this.viewMode === 'week' ? 6 : 13))

            this.post.search.date_range = [start, this.formatDate(endDate, 'yyyy-MM-dd')]

            if (reload) {

                this.search()

            }

        },

        handleSearch () {

            if (this.targetDate) {

                this.locateToDate(this.targetDate)

                return

            }

            this.search()

        },

        handleReset () {

            this.targetDate = ''

            this.post.search.users_id = []

            this.post.search.only_available = false

            this.post.search.include_weekend = false

            this.resetRange()

        },

        locateToDate (dateStr) {

            if (!dateStr) {

                this.search()

                return

            }

            const target = new Date(dateStr)

            const monday = new Date(this.getMonday(target))

            if (this.viewMode === 'week') {

                this.rangeAnchor = this.formatDate(monday, 'yyyy-MM-dd')

            } else {

                const mondayStr = this.formatDate(monday, 'yyyy-MM-dd')

                if (dateStr === mondayStr) {

                    this.rangeAnchor = mondayStr

                } else {

                    const prevMonday = new Date(monday)

                    prevMonday.setDate(prevMonday.getDate() - 7)

                    const secondWeekStart = new Date(prevMonday)

                    secondWeekStart.setDate(secondWeekStart.getDate() + 7)

                    const endOfPrevBiweek = new Date(prevMonday)

                    endOfPrevBiweek.setDate(endOfPrevBiweek.getDate() + 13)

                    if (target >= secondWeekStart && target <= endOfPrevBiweek) {

                        this.rangeAnchor = this.formatDate(prevMonday, 'yyyy-MM-dd')

                    } else {

                        this.rangeAnchor = mondayStr

                    }

                }

            }

            this.applyRange()

        },

        scrollToTargetDate () {

            if (!this.targetDate || !this.dates.includes(this.targetDate)) {

                return

            }

            this.$refs.xTable?.scrollToColumn(this.targetDate)

        },

        search () {

            this.loading = true

            return this.$http.post('/9api/pm/working/schedule', this.post).then((rps) => {

                this.table = rps.data.rows

                this.dates = rps.data.dates

                this.dateRange = rps.data.date_range

                this.today = rps.data.today

                this.$nextTick(() => {

                    this.$refs.xTable?.setAllTreeExpand(true)

                    this.scrollToTargetDate()

                })

                return rps

            }).catch(() => {

                return null

            }).finally(() => {

                this.loading = false

            })

        },

        findScheduleUserRow (userId) {

            return this.table.find((row) => row.row_type === 'user' && Number(row.id) === Number(userId))

        },

        handleCellDrawerChange () {

            const drawer = this.$refs.cellDrawer

            const userId = drawer?.user?.id

            const date = drawer?.date

            const shouldRefreshDrawer = drawer?.visible && userId && date

            this.search().then(() => {

                if (!shouldRefreshDrawer) {

                    return

                }

                const user = this.findScheduleUserRow(userId)

                const day = user?.days?.[date]

                if (user && day) {

                    drawer.refresh({ user, date, day })

                }

            })

        },

        openCell (user, date) {

            const day = user.days?.[date] || {

                status: 'available',

                label: '空闲',

                load: 0,

                actual_load: 0,

                count: 0,

                items: [],

            }

            this.$refs.cellDrawer.open({ user, date, day })

        },

        cellClass (day) {

            if (!day) {

                return 'is-available'

            }

            return 'is-' + (day.status || 'available')

        },

        cellIcon (day) {

            if (!day) {

                return ''

            }

            const map = {

                planned: 'el-icon-date icon planned',

                in_progress: 'el-icon-video-play icon in-progress',

                continuing: 'icon continuing',

                complete: 'el-icon-check icon complete',

                abnormal: 'el-icon-warning icon abnormal',

                leave: 'el-icon-coffee-cup icon leave',

            }

            return map[day.status] || ''

        },

        cellText (day) {

            if (!day) {

                return '-'

            }

            return day.label || '-'

        },

        tableHeaderCellStyle ({ column }) {

            if (column.field === this.today) {

                return { backgroundColor: '#f4f9fd' }

            }

            if (column.field === this.targetDate) {

                return { backgroundColor: '#fdf6ec' }

            }

            return null

        },

        tableCellStyle ({ column, row }) {

            const style = {}

            if (row.row_type === 'organize') {

                style.backgroundColor = '#fafafa'

            }

            if (column.field === this.today) {

                style.backgroundColor = '#f4f9fd'

            } else if (column.field === this.targetDate) {

                style.backgroundColor = '#fdf6ec'

            }

            if (this.dates.includes(column.field)) {

                style.padding = '0'

            }

            return Object.keys(style).length ? style : null

        },

        getMonday (date) {

            const current = new Date(date)

            const day = current.getDay()

            const diff = day === 0 ? -6 : 1 - day

            current.setDate(current.getDate() + diff)

            return this.formatDate(current, 'yyyy-MM-dd')

        },

        weekNumber (dateStr) {

            const date = new Date(dateStr)

            date.setHours(0, 0, 0, 0)

            date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7)

            const week1 = new Date(date.getFullYear(), 0, 4)

            return 1 + Math.round(((date - week1) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7)

        },

        formatDate (value, pattern = 'yyyy-MM-dd') {

            const date = value instanceof Date ? value : new Date(value)

            const pad = (num) => String(num).padStart(2, '0')

            const map = {

                yyyy: date.getFullYear(),

                MM: pad(date.getMonth() + 1),

                dd: pad(date.getDate()),

            }

            return pattern.replace(/yyyy|MM|dd/g, (token) => map[token])

        },

        weekdayLabel (date) {

            const labels = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

            const label = labels[new Date(date).getDay()]

            return date === this.today ? `${label} 今天` : label

        },

    },

}

</script>

<style scoped>

.pm-schedule-page ::v-deep .wu-page-header {

    display: none;

}

.pm-schedule-page ::v-deep .wu-page-search {

    padding: 0 20px 12px;

}

.pm-schedule-page ::v-deep .wu-page-search-form {

    display: block;

    background: transparent;

    padding: 0;

    border-radius: 0;

}

.pm-schedule-page ::v-deep .wu-page-content {

    padding-top: 0;

}



.pm-schedule-header {

    display: flex;

    flex-direction: column;

    gap: 12px;

}



.pm-schedule-title-bar {

    display: flex;

    align-items: center;

    gap: 8px;

    padding-top: 20px;

}

.pm-schedule-title-icon {

    font-size: 22px;

    color: #303133;

}

.pm-schedule-title-text {

    font-size: 18px;

    font-weight: 700;

    color: #303133;

    line-height: 1;

}



.pm-schedule-filter-bar {

    background: #f5f7fa;

    border-radius: 4px;

    padding: 14px 16px 14px;

}

.pm-schedule-filter-form {

    display: flex;

    flex-wrap: wrap;

    align-items: center;

    gap: 8px 24px;

}
.pm-schedule-filter-form ::v-deep .el-form-item {

    margin-bottom: 12px;

}
.pm-schedule-filter-form ::v-deep .el-form-item__label {

    color: #606266;

    padding-right: 8px;

}
.pm-schedule-filter-actions ::v-deep .el-form-item__content {

    margin-left: 0 !important;

}



.pm-schedule-toolbar {

    display: flex;

    align-items: center;

    justify-content: space-between;

    gap: 16px;

    flex-wrap: wrap;

    min-height: 32px;

}
.pm-schedule-toolbar-left,.pm-schedule-toolbar-center,.pm-schedule-toolbar-right {

    display: flex;

    align-items: center;

    gap: 12px;

    flex-wrap: wrap;

}

.pm-schedule-toolbar-center {

    flex: 1;

    justify-content: left;

}
.pm-schedule-toolbar-right {

    justify-content: flex-end;

}

.pm-schedule-view-group ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner,
.pm-schedule-view-group ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner:hover {
    color: #fff;
    background-color: #0027ff;
    border-color: #0027ff;
    box-shadow: -1px 0 0 0 #0027ff;
}

.pm-schedule-view-group ::v-deep .el-radio-button:first-child .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    box-shadow: none !important;
}

.pm-schedule-view-group ::v-deep .el-radio-button__orig-radio:focus + .el-radio-button__inner {
    border-color: #0027ff;
}


.pm-schedule-range {

    color: #409eff;

    font-size: 14px;

    font-weight: 500;

    white-space: nowrap;

    margin-left: 10px;

}



.pm-schedule-switches {

    display: flex;

    align-items: center;

    gap: 20px;

    margin-left: 12px;

}
.pm-schedule-switch-item {

    display: inline-flex;

    align-items: center;

    gap: 8px;

}
.pm-schedule-switch-label {

    color: #606266;

    font-size: 13px;

    white-space: nowrap;

}



.pm-schedule-table {

    position: relative;

    z-index: 0;

    isolation: isolate;

    height: 100%;

}

/* 取消人员行隔行灰色底色 */
.pm-schedule-table ::v-deep .vxe-body--row.row--stripe,
.pm-schedule-table ::v-deep .vxe-body--row.row--stripe > .vxe-body--column {
    background-color: transparent !important;
}
.pm-schedule-table ::v-deep .vxe-body--row:nth-child(even) > .vxe-body--column {
    background-color: transparent;
}

.pm-schedule-table ::v-deep .vxe-body--column .vxe-cell {
    box-sizing: border-box;
    height: 100%;
    padding: 3px;
}

.pm-schedule-table ::v-deep .vxe-body--column.col--tree-node .vxe-cell {
    display: flex;
    align-items: center;
}



.pm-schedule-organize-name {

    font-weight: 600;

    color: #303133;

    overflow: hidden;

    white-space: nowrap;

    text-overflow: ellipsis;

}



.pm-schedule-user-cell {

    display: flex;

    align-items: center;

    gap: 5px;

    width: 100%;

    min-width: 0;

    height: 100%;

}

.pm-schedule-user-cell ::v-deep .el-link {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 26px;
}



.pm-schedule-legend {

    display: inline-flex;

    align-items: center;

    flex-wrap: wrap;

    gap: 14px;

    color: #606266;

    font-size: 12px;

    line-height: 1;

}

.pm-schedule-legend-item {

    display: inline-flex;

    align-items: center;

    gap: 5px;

    white-space: nowrap;

}

.pm-schedule-legend .icon,

.pm-schedule-cell .icon {

    flex-shrink: 0;

    font-size: 18px;

    font-style: normal;

}

.pm-schedule-legend .icon.planned,

.pm-schedule-cell .icon.planned { color: #409eff; }

.pm-schedule-legend .icon.in-progress,

.pm-schedule-cell .icon.in-progress { color: #e6a23c; }

.pm-schedule-legend .icon.continuing,

.pm-schedule-cell .icon.continuing {

    width: 14px;

    height: 14px;

    border: 2px solid #e6a23c;

    border-radius: 50%;

    display: inline-block;

    box-sizing: border-box;

    margin-right: 2px;

}

.pm-schedule-legend .icon.complete,

.pm-schedule-cell .icon.complete { color: #303133; font-weight: 700; }

.pm-schedule-legend .icon.available,

.pm-schedule-cell .icon.available {

    width: 10px;

    height: 10px;

    border-radius: 2px;

    background: transparent;

    border: 1px solid #67c23a;

    display: inline-block;

}

.pm-schedule-legend .icon.no-arrangement,

.pm-schedule-cell .icon.no-arrangement {

    width: 10px;

    height: 10px;

    border-radius: 2px;

    background: transparent;

    border: 1px solid #dcdfe6;

    display: inline-block;

}

.pm-schedule-legend .icon.abnormal,

.pm-schedule-cell .icon.abnormal { color: #f56c6c; }

.pm-schedule-legend .icon.leave,

.pm-schedule-cell .icon.leave { color: #9c59b5; }



.pm-schedule-date-head {

    line-height: 1.2;

    text-align: center;

}

.pm-schedule-date-head.is-today {

    color: #409eff;

    font-weight: 600;

}
.pm-schedule-date-head.is-target {

    color: #e6a23c;

    font-weight: 600;

}

.pm-schedule-date-head .weekday {

    color: #909399;

    font-size: 12px;

}
.pm-schedule-date-head.is-today .weekday {

    color: #409eff;

}
.pm-schedule-date-head.is-target .weekday {

    color: #e6a23c;

}



.pm-schedule-cell {

    box-sizing: border-box;

    height: 100%;

    display: flex;

    align-items: center;

    justify-content: center;

    cursor: pointer;

    font-size: 14px;

    user-select: none;

    border-radius: 2px;

    padding: 0 4px;

}
.pm-schedule-cell-inner {

    display: inline-flex;

    align-items: center;

    gap: 3px;

    line-height: 1;

    text-align: center;

    max-width: 100%;

    min-width: 0;

}

.pm-schedule-cell-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.pm-schedule-cell.is-available {

    background: transparent;

    color: #c0c4cc;

    border: none;

    cursor: pointer;

}
.pm-schedule-cell.is-no_arrangement,

.pm-schedule-cell.is-weekend {

    background: transparent;

    color: #c0c4cc;

    cursor: pointer;

    border: none;

}

.pm-schedule-cell.is-leave {

    color: #9c59b5;

    cursor: pointer;

}

</style>
